<template>
	<div class="message">
		<div class="modal">
			<div class="modal-content mt-2">
				<mifid-content />

				<a
					v-if="!user.isCompany"
					class="btn btn-primary mt-2 text-white d-inline-block text-center"
					rel="noopener noreferrer nofollow"
					style="text-decoration: none !important; margin-right: 12px"
					:href="user.surveyPoolUrl"
					>wypełnij ankiete</a
				>
				<button
					type="button"
					class="btn btn-secondary mb-3"
					@click="acceptInfo()"
				>
					innym razem
				</button>
			</div>
		</div>
		<div class="backdrop"></div>
	</div>
</template>

<script>
import MifidContent from '@/views/mifid/partial/_MifidContent';
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			/* eslint-disable */
			domains: {
				mbankHost: MBANK_HOST,
				mforexHost: MFOREX_HOST,
			},
		};
	},
	methods: {
		mifidQUestionaire() {
			this.$store.commit('setShowPoolInformationDialog', false);
			this.$store.dispatch('pollRefill', true);
		},
		acceptInfo() {
			// this.$store.commit('setShowPoolInformationDialog', false);
			this.$store.dispatch('closeMifidPopup');
		},
	},
	computed: {
		...mapGetters(['getHost', 'getMifidUrl', 'getMifidUrl']),
		user() {
			return this.$store.getters.getUser
				? this.$store.getters.getUser
				: false;
		},
	},
	components: {
		MifidContent,
	},
};
</script>

<style>
.mifid-modal-content {
	background: #fff;
	width: 600px;
	padding: 30px;
	position: fixed;
	z-index: 1010;
	top: 300px;
	left: 50%;
	margin-left: -300px;
}

.mifid-modal-backdrop {
	background: rgba(0, 0, 0, 0.3);
	position: fixed;
	z-index: 1000;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
</style>
